import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';
import {Footer} from '../../components';
import {
  redirectToDataProfessional,
  redirectToTakePhotoDocument,
} from '../../ducks/Navigate';

import './styles.scss';

class DocumentTime extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.DocumentTime.title);
  }

  render = () => (
    <div className="div-document-time">
      <div className="content">
        <div className="header">
          <p>Agora é a vez</p>
          <p>do documento</p>
        </div>
        <div className="subcontent">
          <div className="title">VAI SER RÁPIDO!</div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 197.64 340.55">
            <g id="Layer_2" data-name="Layer 2">
              <g id="Content">
                <path
                  className="cls-1"
                  d="M186.51,340.55H11.13A11.14,11.14,0,0,1,0,329.42V11.13A11.14,11.14,0,0,1,11.13,0H186.51a11.15,11.15,0,0,1,11.13,11.13V329.42A11.15,11.15,0,0,1,186.51,340.55ZM11.13,2.26a8.88,8.88,0,0,0-8.87,8.87V329.42a8.88,8.88,0,0,0,8.87,8.87H186.51a8.87,8.87,0,0,0,8.86-8.87V11.13a8.87,8.87,0,0,0-8.86-8.87Z"
                />
                <path
                  className="cls-1"
                  d="M121.39,306.94h-88a1.12,1.12,0,0,1-1.13-1.13V182.24a1.12,1.12,0,0,1,1.13-1.13h88a1.12,1.12,0,0,1,1.13,1.13V305.81A1.12,1.12,0,0,1,121.39,306.94Zm-86.88-2.26h85.75V183.37H34.51Z"
                />
                <path
                  className="cls-1"
                  d="M121.39,159.44h-88a1.12,1.12,0,0,1-1.13-1.13V34.74a1.13,1.13,0,0,1,1.13-1.14h88a1.13,1.13,0,0,1,1.13,1.14V158.31A1.12,1.12,0,0,1,121.39,159.44Zm-86.88-2.26h85.75V35.87H34.51Z"
                />
                <path
                  className="cls-1"
                  d="M165,306.94a1.13,1.13,0,0,1-1.14-1.13V34.74a1.14,1.14,0,1,1,2.27,0V305.81A1.13,1.13,0,0,1,165,306.94Z"
                />
                <path
                  className="cls-1"
                  d="M102.37,111.9l-13.08-6.53a3.62,3.62,0,0,1-2-3.24V97.5c.32-.39.64-.82,1-1.3a31.42,31.42,0,0,0,4-7.94,5.42,5.42,0,0,0,3.19-4.94V77.84a5.48,5.48,0,0,0-1.37-3.59V67A12.3,12.3,0,0,0,91.28,58c-2.82-3.2-7.38-4.83-13.57-4.83S67,54.84,64.16,58A12.25,12.25,0,0,0,61.3,67v7.28a5.43,5.43,0,0,0-1.37,3.59v5.48a5.42,5.42,0,0,0,2,4.25,28.62,28.62,0,0,0,4.79,9.9V102a3.6,3.6,0,0,1-1.89,3.17l-12.2,6.66a12.35,12.35,0,0,0-6.44,10.84v4.43c0,6.49,20.59,8.21,31.47,8.21s31.48-1.72,31.48-8.21v-4.16a12.28,12.28,0,0,0-6.82-11Zm4.08,15.2c0,1.86-10.14,5.47-28.74,5.47S49,129,49,127.1v-4.43a9.6,9.6,0,0,1,5-8.43l12.2-6.66A6.36,6.36,0,0,0,69.51,102V96.5l-.32-.38a25.73,25.73,0,0,1-4.67-9.67l-.12-.54-.47-.3a2.7,2.7,0,0,1-1.26-2.29V77.84a2.72,2.72,0,0,1,.91-2l.45-.41V66.72a9.53,9.53,0,0,1,2.19-6.87c2.28-2.59,6.14-3.9,11.5-3.9s9.21,1.3,11.48,3.87a9.55,9.55,0,0,1,2.22,6.9v8.69l.45.42a2.68,2.68,0,0,1,.91,2v5.48a2.73,2.73,0,0,1-1.94,2.6l-.68.2-.22.68A28.86,28.86,0,0,1,86,94.62a18.26,18.26,0,0,1-1.14,1.47l-.35.39v5.65a6.31,6.31,0,0,0,3.52,5.68l13.07,6.53a9.56,9.56,0,0,1,5.31,8.6Z"
                />
                <path
                  className="cls-1"
                  d="M81.29,253V247a4.33,4.33,0,0,0-8.66,0v5.47a26.6,26.6,0,0,1-6.84,17.82L59.72,277a1.38,1.38,0,1,0,2.05,1.85l6.08-6.76a29.36,29.36,0,0,0,7.54-19.66V247a1.57,1.57,0,0,1,3.14,0V253a32.48,32.48,0,0,1-8.46,21.88l-5.93,6.52a1.38,1.38,0,0,0,.1,1.95,1.35,1.35,0,0,0,.92.36,1.38,1.38,0,0,0,1-.45l5.92-6.52A35.21,35.21,0,0,0,81.29,253Z"
                />
                <path
                  className="cls-1"
                  d="M87.19,247a10.23,10.23,0,0,0-20.46,0v5.47a20.7,20.7,0,0,1-5.32,13.87l-4.32,4.8a1.38,1.38,0,1,0,2,1.85l4.33-4.8a23.5,23.5,0,0,0,6-15.72V247a7.46,7.46,0,0,1,14.92,0V253a38.37,38.37,0,0,1-10,25.85l-5,5.49a1.39,1.39,0,0,0,.1,2,1.35,1.35,0,0,0,.92.36,1.41,1.41,0,0,0,1-.46l5-5.49A41.15,41.15,0,0,0,87.19,253Z"
                />
                <path
                  className="cls-1"
                  d="M93.08,247a16.12,16.12,0,0,0-32.24,0v5.47A14.86,14.86,0,0,1,57,262.37l-3.89,4.32a1.38,1.38,0,1,0,2,1.85l3.89-4.33a17.56,17.56,0,0,0,4.52-11.77V247a13.36,13.36,0,0,1,26.72,0V253a44.18,44.18,0,0,1-11.53,29.81l-1.38,1.52a1.38,1.38,0,1,0,2,1.86l1.38-1.52A47,47,0,0,0,93.08,253Z"
                />
                <path
                  className="cls-1"
                  d="M54.94,247a1.38,1.38,0,1,0,2.76,0,19.29,19.29,0,0,1,16.51-19.06,1.38,1.38,0,1,0-.4-2.73A22,22,0,0,0,54.94,247Z"
                />
                <path
                  className="cls-1"
                  d="M57.7,252.44a1.38,1.38,0,0,0-2.76,0,8.93,8.93,0,0,1-2.3,6l-3.46,3.85a1.38,1.38,0,0,0,.11,2,1.38,1.38,0,0,0,2-.11l3.46-3.84a11.66,11.66,0,0,0,3-7.83Z"
                />
                <path
                  className="cls-1"
                  d="M96.27,264.78a1.39,1.39,0,0,0-1.69,1,51,51,0,0,1-1.88,5.76,1.37,1.37,0,0,0,.77,1.79,1.32,1.32,0,0,0,.51.1,1.37,1.37,0,0,0,1.28-.87,52.7,52.7,0,0,0,2-6.08,1.39,1.39,0,0,0-1-1.69Z"
                />
                <path
                  className="cls-1"
                  d="M91.67,230.6a1.38,1.38,0,0,0-1.85,2.05A19.29,19.29,0,0,1,96.22,247V253a51,51,0,0,1-.47,6.88,1.37,1.37,0,0,0,1.18,1.56h.19a1.37,1.37,0,0,0,1.36-1.19A53.35,53.35,0,0,0,99,253V247a22,22,0,0,0-7.31-16.37Z"
                />
                <path
                  className="cls-1"
                  d="M85.21,229.57a1.38,1.38,0,1,0,1.19-2.49,21.74,21.74,0,0,0-6.3-1.9,1.38,1.38,0,1,0-.39,2.73,19.22,19.22,0,0,1,5.5,1.66Z"
                />
                <path
                  className="cls-1"
                  d="M77,219.05c-.52,0-1,0-1.56,0a1.38,1.38,0,0,0,.16,2.76c.46,0,.93,0,1.4,0A25.18,25.18,0,0,1,102.11,247V253a1.39,1.39,0,0,0,2.77,0V247A28,28,0,0,0,77,219.05Z"
                />
                <path
                  className="cls-1"
                  d="M61.85,226.55a1.43,1.43,0,0,0,.79-.24,24.72,24.72,0,0,1,7.5-3.55,1.38,1.38,0,1,0-.75-2.66A27.58,27.58,0,0,0,61.06,224a1.38,1.38,0,0,0,.79,2.51Z"
                />
                <path
                  className="cls-1"
                  d="M51.81,252.44V247a25,25,0,0,1,6.85-17.24,1.38,1.38,0,0,0-2-1.9A27.81,27.81,0,0,0,49,247v5.47a3.07,3.07,0,0,1-.78,2l-1.7,1.89a1.38,1.38,0,0,0,.1,1.95,1.35,1.35,0,0,0,.92.36,1.39,1.39,0,0,0,1-.46l1.71-1.9a5.77,5.77,0,0,0,1.49-3.88Z"
                />
                <path
                  className="cls-1"
                  d="M109,236.21a33.62,33.62,0,0,0-7.16-12.09,1.38,1.38,0,1,0-2,1.87,30.73,30.73,0,0,1,6.58,11.1,1.38,1.38,0,0,0,1.31.95,1.32,1.32,0,0,0,.44-.08,1.38,1.38,0,0,0,.87-1.75Z"
                />
                <path
                  className="cls-1"
                  d="M87.88,215a1.38,1.38,0,1,0-.89,2.61,31.21,31.21,0,0,1,8.5,4.49,1.38,1.38,0,0,0,1.94-.28,1.38,1.38,0,0,0-.28-1.93A33.63,33.63,0,0,0,87.88,215Z"
                />
                <path
                  className="cls-1"
                  d="M55.48,224.57A30.91,30.91,0,0,1,77,215.92a31.64,31.64,0,0,1,4.46.32A1.37,1.37,0,0,0,83,215.07a1.38,1.38,0,0,0-1.17-1.57,34.07,34.07,0,0,0-4.85-.34,33.84,33.84,0,0,0-33.78,32.28,1.37,1.37,0,0,0,1.32,1.44h.06a1.38,1.38,0,0,0,1.38-1.32,30.9,30.9,0,0,1,9.54-21Z"
                />
                <path
                  className="cls-1"
                  d="M77,207.26a39.54,39.54,0,0,0-9.15,1.07,1.38,1.38,0,1,0,.63,2.68A37.43,37.43,0,0,1,77,210a36.64,36.64,0,0,1,26.64,11.36,1.35,1.35,0,0,0,1,.43,1.39,1.39,0,0,0,1-2.34A39.62,39.62,0,0,0,77,207.26Z"
                />
                <path
                  className="cls-1"
                  d="M45.91,224.47a1.4,1.4,0,0,0,.85.3,1.37,1.37,0,0,0,1.09-.53,37.29,37.29,0,0,1,15-11.42,1.38,1.38,0,1,0-1.06-2.55,40,40,0,0,0-16.11,12.26,1.38,1.38,0,0,0,.23,1.94Z"
                />
                <path
                  className="cls-1"
                  d="M57.8,208.5a1.32,1.32,0,0,0,.6-.14A42.29,42.29,0,0,1,77,204.13a43.11,43.11,0,0,1,10,1.18,1.38,1.38,0,1,0,.65-2.69A46.06,46.06,0,0,0,77,201.36a45.15,45.15,0,0,0-19.77,4.51,1.38,1.38,0,0,0,.61,2.63Z"
                />
                <path
                  className="cls-1"
                  d="M92.76,207.15A39.78,39.78,0,0,1,97,209.09a1.52,1.52,0,0,0,.65.16,1.39,1.39,0,0,0,.65-2.61,46.28,46.28,0,0,0-4.47-2.06,1.38,1.38,0,0,0-1.79.77,1.39,1.39,0,0,0,.77,1.8Z"
                />
                <path
                  className="cls-1"
                  d="M152.54,219.25c3.58,0,4.54-3.77,3.75-6.67-1.19-4.38-3.63-8.7-5.86-12.62A90.44,90.44,0,0,0,143,188.84a62.09,62.09,0,0,0-4.78-5.59,4.23,4.23,0,0,0-3.84-1.53.69.69,0,0,0-.41,1c8.6,13.29,19.73,24.6,29.79,36.74,2.7,3.25,5.32,6.57,7.78,10,1.13,1.58,2.25,3.18,3.29,4.83.69,1.09.88,3.18-.92,2.66a13.62,13.62,0,0,1-3-1.57,51.44,51.44,0,0,1-16.24-15.28c-2.21-3.25-4.57-7.06-5.55-10.91-.8-3.16.63-5.63,4.1-5.29,2,.2,3.89.78,5.93.61a.69.69,0,0,0,.59-1l-4.26-6.78-.41,1,1.95-.61a.69.69,0,0,0,.48-.83l-1.48-4.11c-.39-1.08-1.76-3.3-.79-4.35.36-.4,1-.33,1.35-.89a2.27,2.27,0,0,0,.3-1.28,9.14,9.14,0,0,0-.39-1.94,3.33,3.33,0,0,1,.7-3.14,3.26,3.26,0,0,0,.22-3.42c-.57-1.56-1-2.29-.28-3.89.34-.73.77-1.12.79-2a5.84,5.84,0,0,0-.67-2.34,9,9,0,0,1-.61-5,43.62,43.62,0,0,0-1.11-16.56l-1.31.36,2.31,6.67.47-.84a3.16,3.16,0,0,1-3.66-2.7l-1.13.66a138.52,138.52,0,0,1,13,11.91l1-1a51,51,0,0,1-14.49-21.64c-.71-2.13-1.68-5.13-1-7.36,1.41-4.39,5.8.42,7.32,1.84a94.29,94.29,0,0,1,9.59,10.48c.47.6,1.48-.19,1.06-.83a161.7,161.7,0,0,0-23-27.58.68.68,0,0,0-1.07.82,60.61,60.61,0,0,0,12.14,18.27.69.69,0,0,0,1.16-.48c-.29-4.87-2.25-9.24-4.32-13.59l-1.17.69,2.09,3.31a.68.68,0,0,0,1.06.14c2.8-3.12,0-6.52-.49-9.89-.39-2.46.52-4.85.55-7.29,0-1.46-1.53-5.12-.16-6,.73-.48,0-1.66-.68-1.18a2.75,2.75,0,0,0-1.21,2.84,14.59,14.59,0,0,0,.42,2.09,12.81,12.81,0,0,1,0,4.82,14.42,14.42,0,0,0-.13,5.74c.63,2.49,2.88,5.56.75,7.93l1.06.14-2.09-3.32a.68.68,0,0,0-1.17.69c2,4.12,3.86,8.27,4.13,12.9l1.16-.48a59.63,59.63,0,0,1-11.93-18l-1.06.82a160,160,0,0,1,22.82,27.31l1.07-.82c-3.75-4.76-8-9.69-12.84-13.35-1.32-1-3.13-1.94-4.73-1s-1.84,3.42-1.79,5.17c.17,5.25,2.94,10.73,5.55,15.17a53,53,0,0,0,10.43,12.64.68.68,0,0,0,1-1,138.52,138.52,0,0,0-13-11.91.69.69,0,0,0-1.14.66,4.5,4.5,0,0,0,5.34,3.65.68.68,0,0,0,.47-.83l-2.31-6.67a.68.68,0,0,0-1.31.36c1.56,5.76,1.46,11.15,1,17a8.63,8.63,0,0,0,.25,3.36c.47,1.53,1.18,2.89.52,4.45s-.94,2.31-.2,4.15a8.18,8.18,0,0,1,.6,1.46c.13,1-.44,1.5-.85,2.19a3.6,3.6,0,0,0-.62,1.38c-.19,1.31,1.14,3.46.31,4.43s-2,.72-1.83,2.45a16.75,16.75,0,0,0,1.2,3.49l1.62,4.52.47-.84-2,.61a.68.68,0,0,0-.4,1l4.26,6.78.58-1c-3.2.28-7.65-2.07-10.35.58s-.84,6.67.4,9.41a53.05,53.05,0,0,0,21.32,23.59c1.33.77,3,1.9,4.6,1.7,4.17-.51.45-5.55-.6-7.1-5.44-8-11.79-15.32-18.15-22.6-7.49-8.56-15-17.12-21.19-26.7l-.41,1c1.79-.28,3.3,2,4.32,3.17s2,2.37,3,3.6a87.37,87.37,0,0,1,5.88,8.5,89,89,0,0,1,4.44,8.21c1.09,2.29,5.88,11.37.23,11.38a.68.68,0,0,0,0,1.36Z"
                />
              </g>
            </g>
          </svg>

          <div className="instruction">
            <p>
              Vamos começar com a <strong>frente</strong> <br /> do seu
              documento. Aceitamos apenas <br />
              CNH, RG ou RNE/CRNM
            </p>
            <p>Centralize o documento na marca.</p>
          </div>
        </div>
      </div>

      <Footer
        backHandle={() => {
          this.props.redirectToDataProfessional();
        }}
        nextHandle={() => this.props.redirectToTakePhotoDocument(false)}
      />
    </div>
  );
}

const mapStateToProps = ({customer}) => {
  return {customer};
};

export default connect(mapStateToProps, {
  redirectToDataProfessional,
  redirectToTakePhotoDocument,
})(DocumentTime);
